// components/RoleManager.js
import React, { useState, useEffect } from 'react';
import { Table, TableHead, TableRow, TableCell, TableBody, TextField, Button } from '@mui/material';
import api from '../utils/api';

const RoleManager = () => {
  const [roles, setRoles] = useState([]);
  const [newRole, setNewRole] = useState('');

  const fetchRoles = () => {
    api.get('/roles-permissions/roles')
      .then((response) => setRoles(response.data))
      .catch((error) => console.error('Error fetching roles:', error));
  };

  const addRole = () => {
    if (newRole.trim()) {
      api.post('/roles-permissions/roles', { role_name: newRole })
        .then(() => {
          setNewRole('');
          fetchRoles();
        })
        .catch((error) => console.error('Error adding role:', error));
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  return (
    <div>
      <h2>Manage Roles</h2>
      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
        <TextField
          label="New Role"
          value={newRole}
          onChange={(e) => setNewRole(e.target.value)}
          size="small"
        />
        <Button variant="contained" onClick={addRole}>
          Add Role
        </Button>
      </div>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Role ID</TableCell>
            <TableCell>Role Name</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {roles.map((role) => (
            <TableRow key={role.role_id}>
              <TableCell>{role.role_id}</TableCell>
              <TableCell>{role.role_name}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default RoleManager;